// extracted by mini-css-extract-plugin
export default {"container":"ProductPage_container__w1IlV","inner":"ProductPage_inner__2saoT"};